function assetSlug(value) {
    if (value == null || value === '') {
        return '';
    }

    return String(value)
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .trim()
        .replace(/[^\w\s-]/g, '')
        .replace(/[\s_-]+/g, '-')
        .replace(/^-+|-+$/g, '');
}

function assetPath(...segments) {
    return segments.map(assetSlug).filter((segment) => segment !== '').join('/');
}

function namesMatch(left, right) {
    return assetSlug(left) === assetSlug(right);
}

module.exports = { assetPath, assetSlug, namesMatch };
